import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

import { getCheckpointById } from '../config';
import CheckpointInput from './CheckpointInput';
import CheckpointsFound from './CheckpointsFound';

const Checkpoint: React.FC = () => {
  const { checkpointId } = useParams<{ checkpointId: string }>();
  const checkpoint = getCheckpointById(checkpointId);
  return (
    <Box sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 1 }}>
        <img className="checkpoint-image" src={checkpoint?.image} />
        <Typography variant="h5">{checkpoint?.name}</Typography>
        <Typography variant="body1">{checkpoint?.description}</Typography>
      </Paper>
      <Paper elevation={3} sx={{ mt: 2, mb: 2, p: 1, pb: 4 }}>
        <Typography variant="body1">
          Kirjoita rastilta löytynyt numero tähän:
        </Typography>
        <CheckpointInput />
      </Paper>
      <Paper elevation={3} sx={{ mt: 2, mb: 4, p: 1 }}>
        <CheckpointsFound />
      </Paper>
    </Box>
  );
};

export default Checkpoint;
